export default __webpack_public_path__ + "static/media/isere.8a357f43.jpg";